<script lang="ts" setup>
  import { computed } from 'vue'
  import { type CheckboxValue } from './BaseCheckbox.types'
  import { TEST_ID } from './BaseCheckbox.constants'

  interface Props {
    modelValue: CheckboxValue
    id: string
    name: string
  }
  interface Emits {
    (e: 'update:modelValue', value: CheckboxValue): void
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: false,
  })
  const emit = defineEmits<Emits>()

  const value = computed({
    get: () => props.modelValue,
    set: (value) => {
      emit('update:modelValue', value)
    },
  })
</script>

<template>
  <div :data-testid="TEST_ID" class="checkbox">
    <input v-model="value" v-bind="$attrs" :id="id" :value="id" :name="name" type="checkbox" />
    <label :for="id">
      <slot />
    </label>
  </div>
</template>

<style lang="scss" scoped>
  @import './BaseCheckbox';
</style>
